import {
  LOGIN_USER_GLORIA,
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
} from "./actionTypes"

export const loginUserGloria = (user, history) => {
  return {
    type: LOGIN_USER_GLORIA,
    payload: { user, history },
  }
}

export const loginUser = (user, history, dataCognito) => {
  return {
    type: LOGIN_USER,
    payload: { user, history, dataCognito },
  }
}

export const loginSuccess = user => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  }
}

export const logoutUser = history => {
  return {
    type: LOGOUT_USER,
    payload: { history },
  }
}

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  }
}

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}
